import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-256f5f53"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "common_user_info" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, null, -1))
const _hoisted_3 = { class: "right_box" }
const _hoisted_4 = { class: "name_box" }
const _hoisted_5 = { class: "name" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("安全退出")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_avatar, {
          size: "small",
          icon: "el-icon-user-solid"
        }),
        _createElementVNode("p", _hoisted_5, "欢迎您： " + _toDisplayString(_ctx.userInfo.username), 1)
      ]),
      _createVNode(_component_el_button, {
        type: "text",
        size: "medium",
        onClick: _ctx.clickLogout
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}